/* EC3D custom cursor — instant coral dot + trailing ring that grows over
   interactive elements. Transform-only (GPU). Port of the React Cursor. */
(function () {
  if (window.__ec3dCursor) return;
  window.__ec3dCursor = true;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var d = document.querySelector('.ec3d-cursor-dot');
  var r = document.querySelector('.ec3d-cursor-ring');
  if (!d || !r) return;

  var mx = window.innerWidth / 2, my = window.innerHeight / 2;
  var rx = mx, ry = my, hot = 0, hotTarget = 0;

  window.addEventListener('mousemove', function (e) {
    mx = e.clientX; my = e.clientY;
    d.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    hotTarget = (e.target.closest && e.target.closest('a, button, input, select, textarea, .ec3d-quiz__opt, .ec3d-reel')) ? 1 : 0;
  }, { passive: true });

  function loop() {
    rx += (mx - rx) * 0.16;
    ry += (my - ry) * 0.16;
    hot += (hotTarget - hot) * 0.14;
    var s = 1 + hot * 0.7;
    r.style.transform = 'translate(' + rx + 'px,' + ry + 'px) scale(' + s + ')';
    r.style.background = 'rgba(242,72,88,' + (hot * 0.14) + ')';
    requestAnimationFrame(loop);
  }
  document.body.classList.add('ec3d-has-cursor');
  requestAnimationFrame(loop);
})();
